module.exports = __webpack_public_path__ + "static/img/registerButton.7dcec84b.png";